var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"num"},[_vm._v(_vm._s(_vm.count))]),_c('button',{on:{"click":_vm.increment}},[_vm._v("自增")])])}
var staticRenderFns = []

export { render, staticRenderFns }